
import * as angular from 'angular';
import { fn } from '@common/utils';
import '../infoma.jquery';

import { $ModalRequestClose, IDialogState } from '@common/services/DialogService';
import { DialogService } from '../services/dialogservice';
import { ISelConfig, RegisterModalShowMultiSelect } from '@common/navkendo/multiselect';

/** Show Modal Reorder Items, returns true if Pending Changes after close */
function ModalShowMultiSelect<T>(config: ISelConfig<T>): PromiseLike<void> {
    var injector = (config.context && angular.element(config.context).injector()) || angular.element(window.document).injector(),
        dlg = injector.get<DialogService>("DialogService"),
        $q = injector.get<ng.IQService>("$q"),
        allItems = config.AllItems.map((t, idx) => {
            var x = {
                uid: kendo.guid(),
                _Item: t,
                Index: -1,
                OrigIndex: -1,
                AllItemsIndex: idx,
                Marked: false,
                Filtered: false,
                Mark: (b: boolean) => {
                    x.Marked = !!b;
                    modalState.RefreshState();
                },
                ToggleSelected(c?: { noRefresh: boolean }) {
                    var idx: number,
                        changed = true;
                    if (x.Index >= 0 && ((idx = chosenItems.indexOf(x)) >= 0)) {
                        // deselect item
                        var insertIdx = unchosenItems.length;
                        fn.FindFirst(unchosenItems, (c, idx) => (c.AllItemsIndex > x.AllItemsIndex) && (!!(insertIdx = idx) || true));
                        unchosenItems.splice(insertIdx, 0, x);
                        chosenItems.splice(idx, 1);
                        x.Marked = false;

                    } else if (x.Index < 0 && ((idx = unchosenItems.indexOf(x)) >= 0)) {
                        // select item
                        chosenItems.push(x);
                        unchosenItems.splice(idx, 1);
                    } else {
                        changed = false;
                    }

                    if (changed) {
                        chosenItems.forEach((item, idx) => item.Index = idx);
                        unchosenItems.forEach((item, idx) => item.Index = -1);
                        if (!(c && c.noRefresh)) {
                            allItems.forEach(item => item.Marked = item === x);
                            modalState.RefreshState();
                            x.ToView();
                        }
                    }
                },
                ToView() {
                    // Unortunately : wait for correct representation in UI
                    window.setTimeout(() => {
                        var el = $('[data-selid="' + x.uid + '"]')[0];
                        if (el)
                            el.scrollIntoView(); // Problem : will scroll even if already visible
                    });
                }
            };
            return x;
        }),
        chosenItems = config.ChosenItems.map(item => fn.FindFirst(allItems, t => t._Item == item)).filter(fn.isSet),
        unchosenItems = fn.except(allItems, chosenItems),
        titleUnchosen = config.TitleUnchosen,
        titleChosen = config.TitleChosen,

        invalid = false,
        inClose = false,
        cancelled = false,
        pendingChanges = false,
        dlgState: IDialogState,
        modalScope: ng.IScope;

    chosenItems.forEach((item, idx) => { item.Index = item.OrigIndex = idx; });

    function resetStateFromContainer() {
        chosenItems.forEach((item, idx) => { item.OrigIndex = item.Index = idx; });
        unchosenItems.forEach((item, idx) => { item.OrigIndex = item.Index = -1; });
    }
    function hasPendingState() {
        return !!fn.FindFirst(allItems, item => item.OrigIndex !== item.Index) || invalid;
    }

    /** Filter Marked Items */
    function _IsMarked(m: { Marked: boolean }) { return m.Marked; }
    /** Filter unmarked Marked Items */
    function _IsNotMarked(m: { Marked: boolean }) { return !m.Marked; }

    // Attached to Modal Controller as 's';
    var modalState = {
        ChosenItems: chosenItems,
        UnchosenItems: unchosenItems,
        AllItems: allItems,
        TitleUnchosen: titleUnchosen,
        TitleChosen: titleChosen,
        FilterText: "",
        /** Aktuel lausstehende Änderungen anwenden */
        ApplyChanges: {
            Enabled: false,
            Hidden: !(config.events && config.events.apply),
            Execute: () => {
                cancelled = false;
                if (hasPendingState()) {
                    var newItems = chosenItems.map((item, idx) => fn.FindFirst(chosenItems, z => z.Index == idx));
                    chosenItems.splice(0, chosenItems.length, ...newItems);
                    var sourceItems = chosenItems.map(item => item._Item);
                    invalid = false;
                    return $q.when(config.events && config.events.apply && config.events.apply(sourceItems)).then(() => {
                        config.ChosenItems.splice(0, config.ChosenItems.length, ...sourceItems);
                        resetStateFromContainer();
                    }).finally(modalState.RefreshState);
                }
            }
        },
        /** Nicht angewandte Änderungen des Benutzers zurücknehmen */
        RevertChanges: {
            Enabled: false,
            Execute: () => {
                if (hasPendingState()) {
                    allItems.forEach(item => item.Index = item.OrigIndex);
                    var _chosenItems = allItems.filter(item => item.Index >= 0).sort((a, b) => a.Index - b.Index);
                    var _unchosenItems = fn.except(allItems, _chosenItems);
                    return $q.when(config.events && typeof (config.events.revert) == "function" && config.events.revert()).then(() => {
                        chosenItems.splice(0, chosenItems.length, ..._chosenItems);
                        unchosenItems.splice(0, unchosenItems.length, ..._unchosenItems);
                        invalid = false;
                        resetStateFromContainer();
                    }).finally(modalState.RefreshState);
                }
                modalState.RefreshState();
            }
        },
        /** Schliessen */
        Close: {
            Execute: () => {
                var result,
                    back = inClose;

                if (modalState.ApplyChanges.Enabled)
                    result = dlg.WhenConfirm("Änderungen anwenden?").then(modalState.ApplyChanges.Execute, modalState.RevertChanges.Execute).finally(() => inClose = true);

                return $q.when(result).then(() => dlgState.closeDialog()).finally(() => { modalState.RefreshState(); inClose = back; });
            }
        },
        AddSelected: {
            Enabled: false,
            Execute: () => {
                var toAdd = unchosenItems.filter(_IsMarked);
                if (toAdd.length == 0)
                    return;
                toAdd.forEach(t => t.ToggleSelected({ noRefresh: true }));
                allItems.forEach(item => item.Marked = toAdd.indexOf(item) >= 0);
                toAdd[0].ToView();
                modalState.RefreshState();
            }
        },
        RemoveSelected: {
            Enabled: false,
            Execute: () => {
                var toRemove = chosenItems.filter(_IsMarked);
                if (toRemove.length == 0)
                    return;
                toRemove.forEach(t => t.ToggleSelected({ noRefresh: true }));
                modalState.RefreshState();
            }
        },
        MoveUp: {
            Enabled: false,
            Execute: () => {
                var toMove = chosenItems.filter(_IsMarked);
                toMove.forEach(move => {
                    var idx = chosenItems.indexOf(move);
                    if (idx > 0 && !chosenItems[idx - 1].Marked) {
                        chosenItems[idx] = chosenItems[idx - 1];
                        chosenItems[idx - 1] = move;
                    }
                });
                chosenItems.forEach((item, idx) => item.Index = idx);
                modalState.RefreshState();
                toMove[0].ToView();
            }
        },
        MoveDown: {
            Enabled: false,
            Execute: () => {
                var toMove = chosenItems.slice(0).reverse().filter(_IsMarked);
                toMove.forEach(move => {
                    var idx = chosenItems.indexOf(move);
                    if (idx < chosenItems.length - 1 && !chosenItems[idx + 1].Marked) {
                        chosenItems[idx] = chosenItems[idx + 1];
                        chosenItems[idx + 1] = move;
                    }
                });
                chosenItems.forEach((item, idx) => item.Index = idx);
                modalState.RefreshState();
                toMove[toMove.length - 1].ToView();
            }
        },
        MoveBegin: {
            Enabled: false,
            Execute: () => {
                var toMove = chosenItems.filter(_IsMarked);
                var toAppend = chosenItems.filter(_IsNotMarked);
                var currentIdx = 0;
                toMove.concat(toAppend).forEach(move => {
                    chosenItems[currentIdx] = move;
                    move.Index = currentIdx;
                    currentIdx++;
                });
                modalState.RefreshState();
                toMove[0].ToView();
            }
        },
        MoveEnd: {
            Enabled: false,
            Execute: () => {
                var toMove = chosenItems.filter(_IsMarked);
                var toPrepend = chosenItems.filter(_IsNotMarked);
                var currentIdx = 0;
                toPrepend.concat(toMove).forEach(move => {
                    chosenItems[currentIdx] = move;
                    move.Index = currentIdx;
                    currentIdx++;
                });
                modalState.RefreshState();
                toMove[0].ToView();
            }
        },
        /** Refresh der Status der Aktionen etc. */
        RefreshState() {

            var selChosenItems = chosenItems.filter(_IsMarked),
                unselChosenItems = chosenItems.filter(_IsNotMarked),
                selectedChosenIdx = selChosenItems.map(item => item.Index),
                unselectedChosenIdx = unselChosenItems.map(item => item.Index),
                hasSelectedChosen = selectedChosenIdx.length > 0,
                hasUnselectedChosen = unselectedChosenIdx.length > 0,
                firstChosenIdx = hasSelectedChosen ? selectedChosenIdx[0] : 0,
                firstUnselChosenIdx = hasUnselectedChosen ? unselectedChosenIdx[0] : 0,
                lastChosenIdx = hasSelectedChosen ? selectedChosenIdx[selectedChosenIdx.length - 1] : 0,
                lastUnselChosenIdx = hasUnselectedChosen ? unselectedChosenIdx[unselectedChosenIdx.length - 1] : 0,
                chosenSpan = lastChosenIdx - firstChosenIdx + 1,
                hasSelectionGap = hasSelectedChosen ? chosenSpan > selChosenItems.length : false;

            modalState.MoveBegin.Enabled = hasSelectedChosen && (hasSelectionGap || firstUnselChosenIdx < lastChosenIdx);
            modalState.MoveUp.Enabled = hasSelectedChosen && (hasSelectionGap || firstChosenIdx > 0);
            modalState.MoveDown.Enabled = hasSelectedChosen && (hasSelectionGap || lastChosenIdx < chosenItems.length - 1);
            modalState.MoveEnd.Enabled = hasSelectedChosen && (hasSelectionGap || lastUnselChosenIdx > firstChosenIdx);

            pendingChanges = invalid || !!fn.FindFirst(allItems, a => a.OrigIndex != a.Index);
            modalState.ApplyChanges.Enabled = modalState.RevertChanges.Enabled = pendingChanges;
            modalState.AddSelected.Enabled = !!fn.FindFirst(unchosenItems, _IsMarked);
            modalState.RemoveSelected.Enabled = !!fn.FindFirst(chosenItems, _IsMarked);
            if (modalScope.$root && !modalScope.$root.$$phase)
                modalScope.$apply();
        },
        /** Externally invalidate state */
        Invalidate() {
            invalid = true;
            modalState.RefreshState();
        }
    };

    function getTemplate(template: string, templateUrl: string) {
        if (template) {
            return $q.when<string>(template);
        } else if (templateUrl) {
            return injector.get<ng.ITemplateRequestService>("$templateRequest")(templateUrl, false);
        } else {
            return $q.reject("No template or templateUrl has been specified!");
        }
    }

    var templateUnchosen = getTemplate(config.TemplateUnchosen, config.TemplateUrlUnchosen),
        templateChosen = getTemplate(config.TemplateChosen, config.TemplateUrlChosen);
    return $q.all([templateUnchosen, templateChosen]).then((resolvedTemplates) => dlg.ShowWindow({
        // TODO: Load window settings/bounds or use this default
        windowOptions: {
            modal: true,
            actions: ["Maximize", "Close"],
            resizable: true,
            width: 670,
            minWidth: 360,
            height: 500,
            title: config.title || "Spaltenkonfiguration"
        },
        mobile : {
            fullScreen: true
        },
        controller: ["$scope", function ModalController($scope) {
            $scope["state"] = modalState;
            $scope["sort"] = <kendo.ui.SortableOptions>{
                hint: function (element: JQuery) {
                    return element.clone().addClass("selhint");
                },
                placeholder: function (element) {
                    return element.clone().addClass("selplaceholder").text("Hier einfügen...");
                },
                end: (e: kendo.ui.SortableEndEvent) => {
                    e.preventDefault();
                    $('.selhint').remove();
                    var itemMoved = chosenItems[e.oldIndex];
                    chosenItems.splice(e.oldIndex, 1);
                    chosenItems.splice(e.newIndex, 0, itemMoved);
                    chosenItems.forEach((item, idx) => item.Index = idx);
                    modalState.RefreshState();
                }
            };

            $scope["TemplateUnchosen"] = resolvedTemplates[0];
            $scope["TemplateChosen"] = resolvedTemplates[1];
            $scope.$watch(() => modalState.FilterText, (newVal, oldVal) => {
                allItems.forEach(item => item.Filtered = !!(config.filter && (newVal && !config.filter(item._Item, newVal))));
                modalState.RefreshState();
            });
        }],
        template: require("./MultiSelect.fragment.html"),
    }).then(_dlgState => {
        dlgState = _dlgState;
        if (_dlgState.window) {
            _dlgState.window.element.css("overflow-y", "hidden");
        }
        modalScope = _dlgState.scope;
        dlgState.scope.$on($ModalRequestClose, (e) => {
            if (!inClose) {
                inClose = true;
                e.preventDefault();
                return $q.when(modalState.Close.Execute()).finally(() => inClose = false);
            }
        });

        return dlgState.close.then(() => { return { Apply: !cancelled && pendingChanges }; }).then(fn.noop);
    }));
}

RegisterModalShowMultiSelect(ModalShowMultiSelect);

export const InfSelectItem = ["$compile", function x($compile: ng.ICompileService): ng.IDirective {
    return <ng.IDirective>{
        scope: {
            item: "=item",
            model: "=model",
            state: "=state",
            template: "=template",
        },
        link: (scope: ng.IScope,
            instanceElement: ng.IAugmentedJQuery,
            instanceAttributes: ng.IAttributes) => {
            var template = scope["template"],
                compileEl = angular.element(template).clone(),
                toAdd = $compile(compileEl)(scope);
            instanceElement.append(toAdd);
        }
    };
}];
